import FileCheckSvg from '@assets/images/svg/file-check.svg';
import React from 'react';
import { View } from 'react-native';

export interface FileCheckIconProps {
    size?: number;
    color?: string;
}

export function FileCheckIcon({ size = 80, color = '#333333' }: FileCheckIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <FileCheckSvg width={size} height={size} color={color} />
        </View>
    );
}

